import { types } from '../../types/types';
const intitalState = {
    reports: [],
};

const moreReportReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.CHANGE_REPORT:
            return {
                ...state,
                reports: action.payload,
            };

        default:
            return { ...state };
    }
};

export default moreReportReducer;
